import { rotinasAcompanhamentos } from "./rotinas";

export default function useRotinasAcompanhamentos() { return rotinasAcompanhamentos; }
